const IN_PROGRESS_STATUSES = new Set([
  "in_transit",
  "out_for_delivery",
  "out_for_pickup",
  "picked_up",
  "partial_picked_up",
  "manifested",
  "received_at_destination_hub",
  "rescheduled",
]);

const SUCCESS_STATUSES = new Set([
  "delivered",
  "delivered_and_installed",
  "delivered_installation_pending",
  "partially_delivered",
]);

const DANGER_STATUSES = new Set([
  "cancelled",
  "failed_to_deliver",
  "failed_to_pickup",
]);

/** Tailwind classes + optional inline style for shipment status pills. */
export const getShipmentStatusPillProps = raw => {
  const s = String(raw || "").toLowerCase();

  if (s === "created") {
    return { className: "bg-primary-lightest text-primary-darkest" };
  }
  if (SUCCESS_STATUSES.has(s)) {
    return { className: "bg-success-light text-grey-900" };
  }
  if (DANGER_STATUSES.has(s)) {
    return { className: "bg-danger-light text-grey-900" };
  }
  if (IN_PROGRESS_STATUSES.has(s)) {
    return {
      className: "text-grey-900",
      style: { backgroundColor: "#FFF3D6", color: "#3B3B3B" },
    };
  }
  return { className: "bg-grey-100 text-grey-700" };
};

export const formatShipmentStatusLabel = raw =>
  String(raw || "").replace(/_/g, " ");
